import { alpha, LinearProgress } from "@mui/material";

export const Loader = () => {
    return (
        <LinearProgress 
            sx={{
                height: '2px',
                backgroundColor: theme => alpha(theme.palette.primary.main, 0.5), 
                '& span': {
                    backgroundColor: theme => theme.palette.primary.main
                }
            }}
        />
    );
  };